import React from 'react';
import { Shield, Eye, Lock } from 'lucide-react';
import { APP_CONFIG } from '../config/appConfig';

export const PrivacyPage: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-8">
      <div>
        <h1 className="text-3xl sm:text-4xl font-black text-navy-950">
          Privacy Policy
        </h1>
        <p className="text-sm text-slate-500 mt-1">
          Effective Date: October 2026 • Version 1.0
        </p>
      </div>

      <div className="bg-white border border-slate-200 rounded-2xl p-6 sm:p-8 space-y-6 text-sm text-slate-700 leading-relaxed shadow-xs">
        <section className="space-y-2">
          <h2 className="text-lg font-bold text-navy-950 flex items-center gap-2">
            <Shield className="w-5 h-5 text-blue-600" />
            <span>1. Our Privacy-First Commitment</span>
          </h2>
          <p>
            SignalNear is built on a privacy-first foundation. You do not need to create an account, log in, or provide personal credentials to use this service or view active public disruption alerts.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-lg font-bold text-navy-950 flex items-center gap-2">
            <Eye className="w-5 h-5 text-blue-600" />
            <span>2. Information We Do Not Collect</span>
          </h2>
          <ul className="list-disc list-inside space-y-1 text-slate-600 pl-2">
            <li>We do <strong>not</strong> track or log your precise GPS coordinates.</li>
            <li>We do <strong>not</strong> sell, rent, or trade visitor data to third-party data brokers.</li>
            <li>We do <strong>not</strong> store personal location histories on our servers.</li>
          </ul>
        </section>

        <section className="space-y-2">
          <h2 className="text-lg font-bold text-navy-950 flex items-center gap-2">
            <Lock className="w-5 h-5 text-blue-600" />
            <span>3. Technical Logs & Caching</span>
          </h2>
          <p>
            When you visit SignalNear, standard anonymous web server logs (such as request timestamps, browser user-agent, and HTTP status codes) may be temporarily processed by our hosting provider (Cloudflare) to detect abuse, protect against Distributed Denial of Service (DDoS) attacks, and maintain service availability.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-lg font-bold text-navy-950">
            4. Local Storage
          </h2>
          <p>
            SignalNear utilizes browser LocalStorage solely to cache National Weather Service alert responses locally on your device for 2 minutes. This minimizes network data usage and ensures fast responsiveness without storing personally identifiable information.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-lg font-bold text-navy-950">
            5. Contact
          </h2>
          <p>
            For privacy inquiries or technical questions regarding data handling, contact us at:{' '}
            <a href={`mailto:${APP_CONFIG.contact.email}`} className="text-blue-600 underline">
              {APP_CONFIG.contact.email}
            </a>
          </p>
        </section>
      </div>
    </div>
  );
};

